import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=700ca37c&"
import script from "./DashboardTable.vue?vue&type=script&lang=js&"
export * from "./DashboardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports